export default {
    vsmList: [],
    vsms:[],
};